import * as React from 'react';
import { ArticleHeading5, IconSalesStart16, IconTrust16, IconEscrou16 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IHouseTitleProps {
  name: string;
  gray: boolean;
  isReliable: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
}

export function HouseTitle({ name, gray, isReliable, isEscrow, isSalesStart }: IHouseTitleProps) {
  return (
    <div className={styles['title']}>
      <ArticleHeading5 color={gray ? 'gray40_100' : 'black_100'}>{name}</ArticleHeading5>
      <div className={styles['labels']}>
        {isReliable && <IconTrust16 color="primary_100" />}
        {isEscrow && <IconEscrou16 color="primary_100" />}
        {isSalesStart && <IconSalesStart16 color="error_100" viewBox="-1 -1 18 18" />}
      </div>
    </div>
  );
}
